
export const state = {
    isModalShow: false,
    isModalHomeShow: false
}

export const mutations = {
    SET_MODAL_SHOW(state, newValue) {
        state.isModalShow = newValue
    },
    SET_MODAL_HOME_SHOW(state, newValue) {
        state.isModalHomeShow = newValue
    }
}

export const getters = {
    getIsModalShow(state) {
        return state.isModalShow
    },
    getIsModalHomeShow(state) {
        return state.isModalHomeShow
    }
}

export const actions = {
    async changeModal({ commit }, value) {
        commit("SET_MODAL_SHOW", value)
    },
    async changeModalHome({ commit }, value) {
        commit("SET_MODAL_HOME_SHOW", value)
    },
}
